/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_InsightsInputs */

const en_read_along_insights = /** @type {(inputs: Read_Along_InsightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insights`)
};

const es_read_along_insights = /** @type {(inputs: Read_Along_InsightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis`)
};

/**
* | output |
* | --- |
* | "Insights" |
*
* @param {Read_Along_InsightsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_insights = /** @type {((inputs?: Read_Along_InsightsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_InsightsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_insights(inputs)
	return en_read_along_insights(inputs)
});